import { DR_Labels } from '@rabbit/data/portal';
import { FBD_Labels } from '@rabbit/data/types';
import { useFirestoreQueryData } from '@react-query-firebase/firestore';
import { query, where } from 'firebase/firestore';

export function useGetLabels({ tenantLink }: { tenantLink: string }) {
  const queryConstraints = [where('tenantLink', '==', tenantLink)];

  const labelQuery = query(DR_Labels.collection(), ...queryConstraints);
  const deleteLabel = async (docid: string) => {
    await FBD_Labels.delete(docid);
  };

  const labelList = useFirestoreQueryData(
    ['labels', tenantLink],
    labelQuery,
    {
      subscribe: true,
    },
    {
      retry: true,
    }
  );

  const upsertLabel = async (input: {
    key: string;
    label: string;
    tenantLink: string;
    createdBy: string;
  }) => {
    const { key, label, tenantLink, createdBy } = input;
    const createNew = async () => {
      const newLabel = FBD_Labels.empty();
      newLabel.key = key;
      newLabel.label = label;
      newLabel.tenantLink = tenantLink;
      newLabel.createdBy = createdBy;
      return await FBD_Labels.set(newLabel);
    };
    const check = await FBD_Labels.query()
      .where('key', '==', key)
      .where('tenantLink', '==', tenantLink)
      .get();
    if (check.length > 0) {
      const found = check[0];
      if (found.body) {
        found.body.label = label;
        found.body.createdBy = createdBy;
        const docid = await FBD_Labels.set(found.body);
        return { ...found.body, docid };
      } else {
        return createNew();
      }
    } else {
      return createNew();
    }
  };

  return {
    labelList,
    deleteLabel,
    upsertLabel,
  };
}
